import { defineStore } from "pinia";
export const useCadastroStore = defineStore("cadastro", {
    state: () => ({
        isSalvando: false,
        isCarregando: false,
        isValidando: false,
        participante: {},
        recaptchaSiteKey: "",
        urlTermosUso: "",
        isLoadedStep: false,
        validationErrors: [],
    }),
    getters: {},
    actions: {
        setRecaptchaSiteKey(key) {
            this.$state.recaptchaSiteKey = key;
        },
        setUrlTermosUso(url) {
            this.$state.urlTermosUso = url;
        },
        clearValidationErrors() {
            this.$state.validationErrors = [];
        },
        addValidationError(error) {
            this.$state.validationErrors.push(error);
        },
    },
});
